/**
 * Turns an axios failure into something an admin can act on.
 *
 * Laravel answers a failed `$this->validate()` on a JSON request with
 * 422 + { message, errors: { field: [msg, ...] } }. Without unpacking that,
 * a duplicate email, a malformed phone number and an expired token all
 * surface as the same "something went wrong", which is what made the nurse
 * forms so hard to get past.
 */

// Maps the API's field names onto the labels shown on the nurse forms.
export const NURSE_FIELD_LABELS = {
  name: "Nama",
  email: "Email",
  password: "Password",
  c_password: "Re-Password",
  gender: "Jenis Kelamin",
  birthdate: "Tanggal Lahir",
  birthplace: "Tempat Lahir",
  address: "Alamat",
  phone_number: "No. Telp",
};

export function apiErrorMessage(err, fieldLabels = {}) {
  const response = err && err.response;
  if (!response) {
    return "Tidak dapat terhubung ke server. Periksa koneksi internet Anda.";
  }

  const data = response.data || {};

  if (response.status === 422 && data.errors) {
    return Object.keys(data.errors)
      .map((field) => {
        const label = fieldLabels[field] || field;
        return `${label}: ${data.errors[field].join(" ")}`;
      })
      .join("\n");
  }

  if (data.message) {
    return data.message;
  }

  if (response.status === 401 || response.status === 403) {
    return "Sesi Anda telah berakhir atau Anda tidak memiliki akses. Silakan login ulang.";
  }

  return "Terjadi kesalahan pada server. Silakan coba lagi.";
}
